import styled from 'styled-components'
import ScheduleGridService from 'services/ScheduleGrid'

const getContainerColor = ({
  schedule, isInProgress, isCompleted, isValidated, isReservation, scheduleStatuses
}) => {
  let statusColor = scheduleStatuses?.find (s => (
    s.codename === schedule.status
  ))?.color || '#373737'

  if (schedule.cutilei_schedule) {
    if (isValidated && isInProgress)
      return '#FFD860'
    else if (isCompleted)
      return isValidated ? '#52A067' : '#DF6969'
    else return '#373737'
  } else {
    return isReservation ? '#A5A5A5' : statusColor
  }
}

/**
 * Linhas de início e fim do bloco na coluna, em coordenadas de CSS Grid (base 1).
 *
 * O casamento por string com a lista de janelas continua sendo o caminho normal, mas
 * deixou de ser o único. Um horário fora da lista -- uma reserva que começa antes da
 * abertura do salão, por exemplo -- é convertido por aritmética e preso ao intervalo
 * visível. Antes o indexOf devolvia -1: o bloco caía na primeira linha da grade e o
 * grid-row-end virava 0, linha que não existe em CSS Grid. O browser descartava a
 * declaração e o bloco desenhava com uma janela de altura, qualquer que fosse a duração.
 */
export const getGridRows = ({
  timewindows, starttime, endtime, timeInterval, schedule, isCompleted, isValidated
}) => {
  const lastRow = Math.max(timewindows.length - 1, 0)
  const clamp = row => Math.min(Math.max(row, 0), lastRow)

  const startIndex = ScheduleGridService.getRowIndex(timewindows, starttime, timeInterval)
  const endIndex = ScheduleGridService.getRowIndex(timewindows, endtime, timeInterval)

  // Um agendamento Cutilei concluído e não validado é desenhado uma janela mais curto.
  const stretchNumber = schedule.cutilei_schedule && isCompleted && !isValidated ? 0 : 1

  const start = (startIndex === null ? 0 : clamp(startIndex)) + 1
  const end = endIndex === null ? start + 1 : clamp(endIndex) + stretchNumber

  // Nunca menor que uma linha: é essa garantia que impede o bloco de colapsar.
  return { start, end: Math.max(end, start + 1) }
}

export const Container = styled.div`
  z-index: ${({ isDragging }) => isDragging ? 10 : 1};
  height: calc(100% - 1px);
  text-decoration: none;
  grid-row-start: ${props => getGridRows (props).start};
  grid-row-end: ${props => getGridRows (props).end};
  grid-column-end: ${({ schedules, schedule, timeInterval, maxConflicts }) => {
    const numConflictingSchedules = ScheduleGridService.getOverlappingSchedules (
      schedules, schedule, timeInterval
    )
    return numConflictingSchedules > 0 ? 'unset' : `span ${maxConflicts + 1}`
  }};
  border: 1px solid #FFFFFF;
  margin: 1px 0px 1px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  overflow: hidden;
  opacity: ${({ isDragging }) => isDragging ? 0.6 : 1};
  cursor: ${({ isDragging }) => isDragging ? 'grabbing' : 'pointer'};
  background-color: ${props => getContainerColor (props)};

  p {
    color: #FFFFFF;
    line-height: 12px;
  }
`

export const Details = styled.div`
  background: #252525;
  height: auto;
  width: 250px;
  margin-bottom: ${({ schedule }) => schedule?.cutilei_schedule ? '0px' : '-5px'};

  p {
    font-size: 14px;
    text-align: left;
  } 
`

export const DetailColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: auto;

  &:last-child {
    margin-left: 5px;
  }
`

export const BlockInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    margin-right: 3px;
    flex-shrink: 0;
  }

  p {
    flex-grow: 1;
    display: flex;
    justify-content: center;
  }
`

export const Row = styled.div`
  width: 100%;
  padding: 0px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
`

export const Image = styled.img`  
  width: 16px;
  height: 16px;
`

export const Picture = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 18px;
  align-self: flex-end;
`

export const InfoText = styled.p`
  font-size: 11px;
  line-height: 15px;
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
  word-break: break-all;
`

export const Light = styled.span`
  height: 16px;
  width: 16px;
  display: ${({ isCompleted, isReservation }) => isCompleted || isReservation ? 'flex' : 'none'};
  border-radius: 20px;
  background-color: ${props => getContainerColor (props)};
`